var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('WidgetTestContainer',[_c('script',{attrs:{"type":"text/x-epodroznik-module","data-module-name":"TicketsPanel","id":"TicketsPanel"}}),_c('div',{ref:"content"})])}
var staticRenderFns = []

export { render, staticRenderFns }